/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AddStory from '../Common/addStory';
import Feature from '../Features/feature';
import Result from '../WorkPackage/result';

const ChildrenTab = ({
  id,
  epicChildren,
  disabled,
  createTemporaryStory,
  updateTemporaryStory,
  capabilityOrganizationLevel,
  epic,
  showDeleted
}) => {
  const childCardType = (level) => (level === 2 ? 'feature' : 'capability');

  return (
    <div>
      <div className="story-header">
        <div className="col-sm-12 feature-add-story">
          <AddStory
            label="CAPABILITY"
            disabled={disabled}
            featureId={id}
            parentId={id}
            level={3}
            result={epic}
            createTemporaryStory={createTemporaryStory}
            isNewWorkPackage={id <= 0}
            organizationLevel={capabilityOrganizationLevel}
            placement="result epic"
          />
        </div>
      </div>
      <div className="story-body">
        <div className="uncategorized">
          {epicChildren.map((child) => {
            if (!child.deleted_at || (showDeleted && child.deleted_at))
              return (
                <div
                  key={child.id ? child.id : child.temporaryId}
                  className="feature-story"
                >
                  {child.level > 1 ? (
                    <Feature
                      item={child}
                      updateTemporaryStory={updateTemporaryStory}
                      type={childCardType(child.level)}
                      noHolon
                    />
                  ) : (
                    <Result
                      result={child}
                      updateTemporaryStory={updateTemporaryStory}
                      isNewFeature={false}
                      noHolon
                      childCard
                    />
                  )}
                </div>
              );
          })}
        </div>
      </div>
    </div>
  );
};

ChildrenTab.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.number,
  epicChildren: PropTypes.array,
  epic: PropTypes.object.isRequired
};

ChildrenTab.defaultProps = {
  disabled: true,
  id: 0,
  epicChildren: []
};

const mapStateToProps = (state) => ({
  showDeleted: state.trashReducer.showTrash
});

export default connect(mapStateToProps)(ChildrenTab);
